import {
  CONFIRMED_GET_PATIENTS,
  CONFIRMED_CREATE_PATIENT_ACTION,
  CONFIRMED_DELETE_PATIENT_ACTION,
  CONFIRMED_EDIT_PATIENT_ACTION,
  CONFIRMED_ADD_MARRIAGE_INFO,
  CONFIRMED_ADD_ADDRESS_INFO,
  CONFIRMED_ADD_OTHER_INFO,
  CONFIRMED_GET_PATIENTS_BY_GENDER,
  CONFIRMED_GET_PATIENT_DETAILS,
  FETCH_FAMILY_TREE_LIST_SUCCESS,
  CONFIRMED_ADD_FAMILY_TREE,
  CONFIRMED_EDIT_FAMILY_TREE,
  CONFIRMED_DELETE_FAMILY_TREE,
} from "../actions/PatientsTypes"

// ✅ Only change: restore from localStorage
const initialState = {
  patientDetails: JSON.parse(localStorage.getItem("selectedPatient")) || null,
  patients: [],
  num_rows: 0,
  marriageInfo: null,
  addressInfo: null,
  otherInfo: null,
  familyTreeList: [],
}

export default function PatientReducer(state = initialState, action) {
  if (action.type === CONFIRMED_GET_PATIENTS) {
    return {
      ...state,
      patients: action.payload.patients || action.payload,
      num_rows: action.payload.num_rows || 0,
    }
  }

  if (action.type === CONFIRMED_GET_PATIENT_DETAILS) {
    // ✅ Store to localStorage for reload persistence
    localStorage.setItem("selectedPatient", JSON.stringify(action.payload))
    return {
      ...state,
      patientDetails: action.payload,
    }
  }

  if (action.type === CONFIRMED_CREATE_PATIENT_ACTION) {
    return {
      ...state,
      patients: [...state.patients, action.payload],
    }
  }

  if (action.type === CONFIRMED_ADD_MARRIAGE_INFO) {
    const patients = [...state.patients]
    const index = patients.findIndex((p) => p.patient_id === action.payload.patient_id)
    if (index !== -1) {
      patients[index] = { ...patients[index], marriageInfo: action.payload }
    }
    return { ...state, patients }
  }

  if (action.type === CONFIRMED_GET_PATIENTS_BY_GENDER) {
    return { ...state, patients: action.payload }
  }

  if (action.type === CONFIRMED_ADD_ADDRESS_INFO) {
    const patients = [...state.patients]
    const index = patients.findIndex((p) => p.patient_id === action.payload.patient_id)
    if (index !== -1) {
      patients[index] = { ...patients[index], addressInfo: action.payload }
    }
    return { ...state, patients }
  }

  if (action.type === CONFIRMED_ADD_OTHER_INFO) {
    const patients = [...state.patients]
    const index = patients.findIndex((p) => p.patient_id === action.payload.patient_id)
    if (index !== -1) {
      patients[index] = { ...patients[index], otherInfo: action.payload }
    }
    return { ...state, patients }
  }

  if (action.type === CONFIRMED_DELETE_PATIENT_ACTION) {
    return {
      ...state,
      patients: state.patients.filter((p) => p.patient_id !== action.payload.patient_id),
    }
  }

  if (action.type === CONFIRMED_EDIT_PATIENT_ACTION) {
    const updatedPatientId = action.payload.patient_id

    const updatedPatients = state.patients.map((patient) =>
      patient.patient_id === updatedPatientId
        ? { ...patient, ...action.payload }
        : patient
    )

    const updatedPatientDetails =
      state.patientDetails && state.patientDetails.patient_id === updatedPatientId
        ? { ...state.patientDetails, ...action.payload }
        : state.patientDetails

    // ✅ Keep localStorage in sync only if same patient updated
    if (updatedPatientDetails) {
      localStorage.setItem("selectedPatient", JSON.stringify(updatedPatientDetails))
    }

    return {
      ...state,
      patients: updatedPatients,
      patientDetails: updatedPatientDetails,
    }
  }

  if (action.type === FETCH_FAMILY_TREE_LIST_SUCCESS) {
    return {
      ...state,
      familyTreeList: Array.isArray(action.payload) ? action.payload : [],
    }
  }

  if (action.type === CONFIRMED_ADD_FAMILY_TREE) {
    return { ...state, familyTreeList: [...state.familyTreeList, action.payload] }
  }

  if (action.type === CONFIRMED_EDIT_FAMILY_TREE) {
    return {
      ...state,
      familyTreeList: state.familyTreeList.map((item) =>
        item.family_id === action.payload.family_id ? { ...item, ...action.payload } : item
      ),
    }
  }

  if (action.type === CONFIRMED_DELETE_FAMILY_TREE) {
    return {
      ...state,
      familyTreeList: state.familyTreeList.filter((item) => item.family_id !== action.payload.family_id),
    }
  }

  return state
}
